import React, { useState } from "react";
import Modal from "react-modal";

// Import images for the gallery
import pg1 from "./../assets/gallery/pg1.jpg";
import pg2 from "./../assets/gallery/pg2.jpg";
import pg3 from "./../assets/gallery/pg3.jpg";
import pg4 from "./../assets/gallery/pg4.webp";
import pg5 from "./../assets/gallery/pg5.jpg";
import pg6 from "./../assets/gallery/pg6.jpg";
import pg7 from "./../assets/gallery/pg7.webp";
import pg8 from "./../assets/gallery/pg8.webp";
import pg9 from "./../assets/gallery/pg9.webp";
import pg10 from "./../assets/gallery/pg10.webp";
import o2 from "./../assets/gallery/ps2.jpg";
import o5 from "./../assets/gallery/ps5.jpg";
import o6 from "./../assets/gallery/ps6.jpg";
import o8 from "./../assets/gallery/ps8.jpg";
import o9 from "./../assets/gallery/ps9.jpg";
import o12 from "./../assets/gallery/ps12.jpg";
import o15 from "./../assets/gallery/ps15.jpg";
import o28 from "./../assets/gallery/ps28.jpg";
import o34 from "./../assets/gallery/ps34.jpg";
import o59 from "./../assets/gallery/ps59.jpg";
import o60 from "./../assets/gallery/ps60.jpg";
import o64 from "./../assets/gallery/ps64.jpg";
import o65 from "./../assets/gallery/ps65.jpg";
import o66 from "./../assets/gallery/ps66.jpg";
import o71 from "./../assets/gallery/ps71.jpg";
import o72 from "./../assets/gallery/ps72.jpg";

// Data for gallery images
const galleryImages = [
  { url: pg1 },
  { url: pg2 },
  { url: pg3 },
  { url: pg4 },
  { url: pg5 },
  { url: pg6 },
  { url: pg7 },
  { url: pg8 },
  { url: pg9 },
  { url: pg10 },
  { url: o2 },
  { url: o5 },
  { url: o6 },
  { url: o8 },
  { url: o9 },
  { url: o12 },
  { url: o15 },
  { url: o28 },
  { url: o34 },
  { url: o59 },
  { url: o60 },
  { url: o64 },
  { url: o65 },
  { url: o66 },
  { url: o71 },
  { url: o72 },
];

const GalleryItem = ({ image, onClick }) => (
  <div className="relative my-4 cursor-pointer" onClick={onClick}>
    <img
      src={image.url}
      alt="Gallery Item"
      className="object-cover w-full h-full"
      style={{ aspectRatio: "5/3", width: "100%", height: "auto" }}
    />
    <div className="absolute inset-0 bg-black bg-opacity-50 flex justify-center items-center opacity-0 hover:opacity-100 transition-opacity duration-300">
      <h2 className="text-white text-2xl font-bold">View</h2>
    </div>
  </div>
);

const Gallery = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = (image, index) => {
    setSelectedImage(image.url);
    setCurrentIndex(index);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedImage(null);
  };

  const nextImage = () => {
    const newIndex = (currentIndex + 1) % galleryImages.length;
    setSelectedImage(galleryImages[newIndex].url);
    setCurrentIndex(newIndex);
  };

  const prevImage = () => {
    const newIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    setSelectedImage(galleryImages[newIndex].url);
    setCurrentIndex(newIndex);
  };

  return (
    <div>
      <h1 className="text-4xl md:text-7xl text-center leading-8 font-montserrat font-medium tracking-widest p-12 md:p-32">
        GALLERY
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-6">
        {galleryImages.map((image, index) => (
          <GalleryItem
            key={index}
            image={image}
            onClick={() => openModal(image, index)}
          />
        ))}
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Gallery Image"
        className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
        overlayClassName="fixed inset-0 bg-black bg-opacity-75"
      >
        <div className="bg-white p-4 rounded-lg max-w-7xl w-full relative">
          <button
            className="text-black font-bold mb-4"
            onClick={closeModal}
          >
            Close
          </button>
          {selectedImage && (
            <div className="flex justify-center items-center relative">
              <button
                className="absolute left-0 text-white text-4xl font-bold p-2"
                onClick={prevImage}
              >
                &#10094;
              </button>
              <img
                src={selectedImage}
                alt="Selected"
                className="object-cover w-full h-full"
                style={{ maxHeight: "80vh", maxWidth: "80vw" }}
              />
              <button
                className="absolute right-0 text-white text-4xl font-bold p-2"
                onClick={nextImage}
              >
                &#10095;
              </button>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default Gallery;
